import { render } from "./FormTextarea.vue?vue&type=template&id=362f15d6"
import script from "./FormTextarea.vue?vue&type=script&lang=ts"
export * from "./FormTextarea.vue?vue&type=script&lang=ts"

import "./FormTextarea.vue?vue&type=style&index=0&id=362f15d6&lang=scss"
script.render = render

export default script